import { MDBInput, MDBTextArea, MDBAutocomplete } from "mdb-react-ui-kit";

import React, { useState, useEffect, useRef } from "react";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import { LocAddressSeach } from "../../../apiclients/streamsapi_bridge";
import { CANADA, USA } from "../../images";

export default function BillingAddress({
  register,
  watch,
  setValue,
  errors,
  countryList,
  states, clearErrors,
  setIsSameAsBilling,
  isSameAsBilling
}) {

  const [addressReasults, setAddressReasults] = useState([]);
  const [isDisplay, setisDisplay] = useState(false);
  const allowAPI = useRef(true);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [originalBilling, setOriginalBilling] = useState({});
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsSameAsBilling(checked);

    if (checked) {
      setOriginalBilling({
        street_addr1: watch("address.bill_addr.street_addr1"),
        street_addr2: watch("address.bill_addr.street_addr2"),
        specific_location: watch("address.bill_addr.specific_location"),
        city: watch("address.bill_addr.city"),
        state: watch("address.bill_addr.state"),
        zip: watch("address.bill_addr.zip"),
        country: watch("address.bill_addr.country"),
      });

      setValue("address.bill_addr.street_addr1", watch("address.loc_addr.street_addr1") ?? "", { shouldDirty: true });
      setValue("address.bill_addr.street_addr2", watch("address.loc_addr.street_addr2") ?? "", { shouldDirty: true });
      setValue("address.bill_addr.specific_location", watch("address.loc_addr.specific_location") ?? "", { shouldDirty: true })
      setValue("address.bill_addr.city", watch("address.loc_addr.city") ?? "", { shouldDirty: true });
      setValue("address.bill_addr.state", parseInt(watch("address.loc_addr.state") ?? 0), { shouldDirty: true });
      setValue("address.bill_addr.zip", watch("address.loc_addr.zip") ?? "", { shouldDirty: true });
      setValue("address.bill_addr.country", watch("address.loc_addr.country") ?? "", { shouldDirty: true });

    } else {
      setValue("address.bill_addr.street_addr1", originalBilling.street_addr1 ?? "", { shouldDirty: true });
      setValue("address.bill_addr.street_addr2", originalBilling.street_addr2 ?? "", { shouldDirty: true });
      setValue("address.bill_addr.specific_location", originalBilling.specific_location ?? "", { shouldDirty: true })
      setValue("address.bill_addr.city", originalBilling.city ?? "", { shouldDirty: true });
      setValue("address.bill_addr.state", originalBilling.state ?? 0, { shouldDirty: true });
      setValue("address.bill_addr.zip", originalBilling.zip ?? "", { shouldDirty: true });
      setValue("address.bill_addr.country", originalBilling.country ?? "", { shouldDirty: true });
    }
  };

  console.log("state list :::::::::::::" + states)
  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleSearchAddressChange(searchValue) {
    try {
      clearErrors("address.bill_addr.street_addr1");
      setValue("address.bill_addr.street_addr1", searchValue, { shouldDirty: true });
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
      const newTimeout = setTimeout(() => {
        sendApIRequest(searchValue);
      }, 500);
      // Update the typingTimeout state with the new timeout
      setTypingTimeout(newTimeout);
    } catch (error) {
      console.log(`Error in handleSearchAddressChange :::: ${error}`);
    }
  }

  const sendApIRequest = async (searchValue) => {
    try {
      if (searchValue.trim() !== "" && allowAPI.current) {
        //if (searchValue.trim() !== "") {
        let update = {
          reqid: 84,
          search: searchValue,
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        };
        setIsLoading(true);
        console.log("Request for the search :::::: " + JSON.stringify(update));
        const serverResponse = await LocAddressSeach(update);
        setIsLoading(false);
        if (!serverResponse.ok) {
          console.log("Network response was not ok");
          throw new Error("Network response was not ok");
        } else {
          const responseData = await serverResponse.json();
          console.log("Response Data:", JSON.stringify(responseData));
          let addressList = responseData?.message?.suggestions ?? [];
          setAddressReasults(addressList);
          if (addressList.length === 0) {
            setisDisplay(false);
          } else {
            setisDisplay(true);
          }
        }
      } else {
        allowAPI.current = true;
        setisDisplay(false);
      }
    } catch (error) {
      console.log(`Error in sendApIRequest for address search :::: ${error}`);
    }
  };
  function handleAddressSelect(address) {
    if (address.street_line) {
      // setaddressValue(address.street_line);
      setValue("address.bill_addr.street_addr1", address.street_line, {
        shouldDirty: true,
      });
    }
    if (address.secondary) {
      setValue("address.bill_addr.street_addr2", address.secondary, {
        shouldDirty: true,
      });
    } else {
      setValue("address.bill_addr.street_addr2", "", {
        shouldDirty: true,
      });
    }
    if (address.city) {
      setValue("address.bill_addr.city", address.city, { shouldDirty: true });
    }

    if (address.state) {
      const stateObj = states.find(
        (state) => state.statecode?.trim() === address.state?.trim()
      );
      console.log("stateObj :::::::: " + JSON.stringify(stateObj));

      if (stateObj) {
        setValue("address.bill_addr.state", stateObj.sid, {
          shouldDirty: true,
        });
      }
    }

    if (address.zipcode) {
      setValue("address.bill_addr.zip", address.zipcode, { shouldDirty: true });
    }
  }

  return (
    <div>
      <div className="general-settings mb-1" id="general">
        Billing Address
      </div>
      <div className="d-flex align-items-center" style={{ paddingLeft: "10px" }}>
        <input
          type="checkbox"
          checked={isSameAsBilling}
          onChange={handleCheckboxChange}
          id="sameAsLocation"
        />
        <label className="form-check-label" htmlFor="sameAsLocation" >
          Same as location address
        </label>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">
          Street Address 1 <span className="text-danger">*</span>
        </div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            {/* <MDBTextArea
              value={watch("address.bill_addr.street_addr1")}
              onChange={(e) => {
                setValue("address.bill_addr.street_addr1", e.target.value, {
                  shouldDirty: true,
                });
              }}
            /> */}
            <MDBAutocomplete
              data={addressReasults}
              // value={addressValue}
              value={watch("address.bill_addr.street_addr1")}
              displayValue={(address) => address.street_line}
              isLoading={isLoading}
              // open={isDisplay}
              placeholder="Address 1"
              onSearch={handleSearchAddressChange}
              onSelect={(e) => {
                allowAPI.current = false;
                setisDisplay(false);
              }}
              itemContent={(address) => (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    allowAPI.current = false;
                    handleAddressSelect(address);
                  }}
                >
                  {address.country && (
                    <img
                      src={address.country === "USA" ? USA : CANADA}
                      className="me-3"
                      width={25}
                    />
                  )}
                  {address.street_line || ""}
                  {address.secondary ? ", " + address.secondary : ""}
                  {address.city ? ", " + address.city : ""}
                  {address.state ? ", " + address.state : ""}
                  {address.zipcode ? ", " + address.zipcode : ""}
                </div>
              )}
            />
            {errors.address?.bill_addr?.street_addr1 && (
              <p className="text-danger">
                {errors?.address?.bill_addr?.street_addr1.message}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">Street Address 2</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBTextArea
              value={watch("address.bill_addr.street_addr2")}
              onChange={(e) => {
                setValue("address.bill_addr.street_addr2", e.target.value, {
                  shouldDirty: true,
                });
              }}
            />
            {errors.address?.bill_addr?.street_addr2 && (
              <p className="text-danger">
                {errors?.address?.bill_addr?.street_addr2.message}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">Specific Location</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBInput
              {...register("address.bill_addr.specific_location", {
                // required: "Specific Location is required", // Example of validation
              })}
            />
            {errors?.address?.bill_addr?.specific_location && (
              <p className="text-danger">
                {errors?.address?.bill_addr?.specific_location.message}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">
          City/Town <span className="text-danger">*</span>
        </div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBInput
              {...register("address.bill_addr.city", {
                required: "city is required",
              })}
            />
            {errors.address?.bill_addr?.city && (
              <p className="text-danger">
                {errors?.address?.bill_addr?.city.message}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">
          State/Province <span className="text-danger">*</span>
        </div>
        <div className="d-flex w-30">
          <select
            className="form-control form-select w-100 selectname"
            value={watch("address.bill_addr.state")}
            onChange={(e) => {
              setValue("address.bill_addr.state", parseInt(e.target.value), {
                shouldDirty: true,
              });
            }}
          >
            {states &&
              states.map((loc) => (
                <option value={parseInt(loc.sid)}>{loc.sname}</option>
              ))}
          </select>
          {errors.address?.bill_addr?.state && (
            <p className="text-danger">
              {errors?.address?.bill_addr?.state.message}
            </p>
          )}
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">
          Country <span className="text-danger">*</span>
        </div>
        <div className="d-flex w-30">
          <select
            className="form-control form-select w-100 selectname"
            value={watch("address.bill_addr.country")}
            onChange={(e) => {
              setValue("address.bill_addr.country", e.target.value, {
                shouldDirty: true,
              });
            }}
          >
            {countryList &&
              countryList.map((loc) => (
                <option value={loc.id}>{loc.cname}</option>
              ))}
          </select>
          {errors.address?.bill_addr?.country && (
            <p className="text-danger">
              {errors?.address?.bill_addr?.country.message}
            </p>
          )}
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">
          ZIP Code <span className="text-danger">*</span>
        </div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100">
            <MDBInput
              {...register("address.bill_addr.zip", {
                required: "zip code is required",
              })}
            />
            {errors.address?.bill_addr?.zip && (
              <p className="text-danger">
                {errors?.address?.bill_addr?.zip.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
